import { ReactElement } from 'react'

import { clsx } from 'clsx'

import { Skeleton } from '@/app/[locale]/[ferry]/Skeleton'
import { RouteIllustration } from '@/components/yourbooking/departures/departure-row/DepartureRow'
import ChevronDownIcon from '@/ui-cvi/components/dxp-icons/system/ChevronDownIcon'

const RowSkeleton = (): ReactElement => (
  <div className="bg-semantic-global-background-white border-semantic-global-border-light border" data-e2e="departure-row-skeleton">
    {/* Mobile */}
    <div className="gap-semantic-global-md py-primitive-16 px-semantic-global-md flex h-full w-full flex-col md:hidden">
      <div className="gap-semantic-global-xs flex flex-col">
        <div className="text-dfds-text-dark-secondary">
          <Skeleton className="h-4 w-50" />
        </div>
        <div className="text-dfds-text-dark-secondary">
          <Skeleton className="h-4 w-37.5" />
        </div>
      </div>

      <div className="gap-semantic-global-sm flex flex-row">
        <div className="gap-semantic-global-xs flex flex-1 flex-col">
          <div className="text-dfds-text-primary-primary">
            <Skeleton className="h-6 w-full" />
          </div>
          <div className="text-dfds-text-primary-primary">
            <Skeleton className="h-5 w-full" />
          </div>
        </div>
        <div className="gap-primitive-8 text-dfds-text-primary-primary flex w-25 items-center justify-center">
          <RouteIllustration />
        </div>
        <div className="gap-semantic-global-xs flex flex-1 flex-col">
          <div className="text-dfds-text-primary-primary">
            <Skeleton className="h-6 w-full" />
          </div>
          <div className="text-dfds-text-primary-primary">
            <Skeleton className="h-5 w-full" />
          </div>
        </div>
      </div>
      <div className="gap-semantic-global-xs flex flex-row">
        <div className="text-dfds-text-dark-secondary mt-auto ml-auto">
          <Skeleton className="h-6.5 w-12.5" />
        </div>
        <div className="text-dfds-text-dark-secondary">
          <Skeleton className="h-8 w-37.5" />
        </div>
      </div>
    </div>

    {/* Desktop */}
    <div className="hidden h-26.75 w-full flex-row md:flex">
      {/* Departure information */}
      <div className="flex flex-1 flex-row">
        <div className="flex flex-1 items-center">
          <div className="p-semantic-global-lg gap-semantic-global-sm flex flex-row">
            <div className="gap-semantic-global-xs flex flex-col">
              <div className="text-dfds-text-primary-primary">
                <Skeleton className="h-6 w-12.5" />
              </div>
              <div className="text-dfds-text-primary-primary">
                <Skeleton className="h-6 w-12.5" />
              </div>
            </div>
            <div className="gap-primitive-8 text-dfds-text-primary-primary flex w-32.5 items-center justify-center">
              <RouteIllustration />
            </div>
            <div className="gap-semantic-global-xs flex flex-col">
              <div className="text-dfds-text-primary-primary">
                <Skeleton className="h-6 w-12.5" />
              </div>
              <div className="text-dfds-text-primary-primary">
                <Skeleton className="h-6 w-12.5" />
              </div>
            </div>
          </div>

          <div className="p-semantic-global-lg gap-semantic-global-xs flex flex-col">
            <div className="text-dfds-text-dark-secondary">
              <Skeleton className="h-5 w-37.5" />
            </div>
            <div className="text-dfds-text-dark-secondary">
              <Skeleton className="h-5 w-37.5" />
            </div>
          </div>
        </div>
      </div>

      {/* Price */}
      <div className="bg-semantic-global-background-white border-semantic-global-border-light ml-auto w-45 border-l">
        <div className="p-semantic-global-lg relative flex h-full justify-center">
          <div className={clsx('gap-primitive-4 text-dfds-text-primary-primary flex flex-col items-start')}>
            <span className="typography-body-md-regular">
              <Skeleton className="h-6 w-12.5" />
            </span>
            <span className="typography-heading-md" data-e2e="price">
              <Skeleton className="h-8 w-25" />
            </span>
          </div>
        </div>
      </div>

      <div className="border-semantic-global-border-light px-semantic-global-md flex items-center border-l">
        <ChevronDownIcon size="md" />
      </div>
    </div>
  </div>
)

export default RowSkeleton
